export const RECRUITMENT_BASE_URL = process.env.REACT_APP_RECRUITMENT;
// export const EDITORS_BASE_URL_WHOLE = `${process.env.REACT_APP_EDITORS}/admin/editors`;

const ADMIN_APPLICATION = "/admin/applications";

export const ENDPOINT_EDITORS = () => "/admin/editors";
export const ENDPOINT_APPLICATIONS = (searchString?: string) => searchString && searchString !== "" ? `${ADMIN_APPLICATION}?query=${searchString}` : `${ADMIN_APPLICATION}`;
export const ENDPOINT_APPLICATIONS_STATUS = (applicationStatus?: string) => applicationStatus && applicationStatus !== "Auswahl" ? `${ADMIN_APPLICATION}?status=${applicationStatus}`: `${ADMIN_APPLICATION}`;
export const ENDPOINT_APPLICATION_DETAILS = (id: string) => `${ADMIN_APPLICATION}/${id}`;
// export const ENDPOINT_APPLICATION_ASSIGNED_TO_ME = (id: number) => `${ADMIN_APPLICATION}?editor=${id}`; //from dashboard
export const ENDPOINT_USER_DASHBOARD = () => "/admin/dashboard";
export const ENDPOINT_HISTORY = (id: number) => `${ADMIN_APPLICATION}/${id}/history`;
export const ENDPOINT_TRANSLATIONS = (language: string) => `/papi/v1/translations/${language}`;
// https://recruitment-dev.pro.win/admin/dashboard

export const POST_ENDPOINT_EDITOR_NOTE = (id: number) => `${ADMIN_APPLICATION}/${id}/note`;
export const POST_APPLICATION_QUESTIONS = (id: number) => `${ADMIN_APPLICATION}/${id}/inquiries`;

export const PUT_ENDPOINT_DECLINE = (id: number) => `/admin/decline-application/${id}`;
export const PUT_ENDPOINT_EDIT_EDITOR_NOTE = (id: number) => `${ADMIN_APPLICATION}/${id}/note`;
export const PUT_ENDPOINT_ABORT = (id: number) => `/admin/abort-application/${id}`;
export const PUT_CHANGE_EDITOR = (id: number) => `${ADMIN_APPLICATION}/${id}/editor`;
export const PUT_TRANSFER_APPLICATION = (id: number) => `/admin/sync-application/${id}`;

export const GET_BLACKLIST = () => `/admin/blacklisted-emails`;
export const DELETE_BLACKLIST_ITEM = (id: number) => `/admin/blacklisted-emails/${id}`;

// https://recruitment-local.pro.win/admin/applications?editor=2&status=pending,in-sync